module.exports = __webpack_public_path__ + "ebfa2f134c86190f1f7ebfe40f4965c3.png";